import { pick } from 'ramda';

export default pick([
  'autoplay',
  'controls',
  'height',
  'loop',
  'muted',
  'poster',
  'preload',
  'src',
  'width',
]);
